// material-ui
import { useTheme } from '@mui/material/styles';

import logoDark from 'assets/images/logo_dark.png';
import logo from 'assets/images/logo.png';

const Logo = () => {

    const theme = useTheme();

    return (
        <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Turfoplay" width="130" height="30" />
    );
};

export default Logo;
